import {
    config,
} from './utils';

const getInscricaoInfos = async (evento_id) => {
    const request = await fetch(config.apiUrl + '/api/inscricao/get-infos/' + evento_id, {
        credentials: 'include',
        mode: 'cors',
    });
    const response = await request.json();
    if (request.status !== 200) {
        throw response;
    }
    return response;
};

const saveInscricao = async (formData) => {
    const request = await fetch(config.apiUrl + '/api/inscricao/save-inscricao', {
        method: 'POST',
        body: formData,
        credentials: 'include',
        mode: 'cors',
    });
    const response = await request.json();
    if (request.status !== 200) {
        throw response;
    }
    return response;
};

const urlResumoInscricao = (token_inscricao, download) => {
    return config.apiUrl + '/api/inscricao/resumo-inscricao/' + token_inscricao + (download ? '?download=true' : '');
};

const urlPDFAvaliacao = (token_inscricao, download) => {
    return config.apiUrl + '/api/inscricao/pdf-avaliacao-inscricao/' + token_inscricao + (download ? '?download=true' : '');
};

const urlArquivoInscricao = (token_inscricao, download) => {
    return config.apiUrl + '/api/inscricao/arquivo-inscricao/' + token_inscricao + (download ? '?download=true' : '');
};

const urlTextoTrabalhoInscricao = (token_inscricao) => {
    return config.apiUrl + '/api/inscricao/texto-inscricao/' + token_inscricao;
};

const urlZipInscricoes = async (token_inscricoes) => {
    return new Promise((resolve) => {
        const x = new XMLHttpRequest();
        x.open('POST', config.apiUrl + '/api/inscricao/zip-inscritos', true);
        x.setRequestHeader('Content-Type', 'application/json');
        x.withCredentials = true;
        x.responseType = 'blob';
        x.onload = (e) => resolve({ e, request: x });
        x.send(JSON.stringify({ tokens: token_inscricoes }));
    });
    // const request = await fetch(config.apiUrl + '/api/inscricao/zip-inscritos', {
    //     method: 'POST',
    //     body: JSON.stringify({ tokens: token_inscricoes }),
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     credentials: 'include',
    //     mode: 'cors',
    // });
    // return request;
};

const urlCSVInscricoes = (evento_id) => {
    return config.apiUrl + '/api/admin/csv-inscritos/' + evento_id;
};

export {
    getInscricaoInfos,
    saveInscricao,
    urlResumoInscricao,
    urlPDFAvaliacao,
    urlZipInscricoes,
    urlArquivoInscricao,
    urlTextoTrabalhoInscricao,
    urlCSVInscricoes,
};